/**
 * The current pathname, with any query string or hash removed.
 *
 * preact-iso's `location.path` is already a bare pathname, but it falls back to `url` — which
 * carries `?query` and `#hash` — and to `window.location.pathname` on the server-less path. Code
 * that matches a route with an anchored regex therefore silently stops matching the moment a
 * query string appears, which is the kind of failure nobody notices until a link with a tracking
 * parameter lands on the wrong view.
 *
 * A trailing slash is trimmed too, so `/leads/companies/` matches `/leads/companies`.
 */
export function currentPathname(location: unknown): string {
  const source = location as { path?: string; url?: string } | null | undefined
  const raw = source?.path
    || source?.url
    || (typeof window !== 'undefined' ? window.location.pathname : '')

  const withoutQuery = raw.split('?')[0].split('#')[0]
  return withoutQuery.length > 1 ? withoutQuery.replace(/\/+$/, '') : withoutQuery
}
